import { useState } from "react";
import { Card, Tabs, useMantineTheme } from "@mantine/core";
import WebIntegration from "./WebIntegration";
import LocationDetail from "./LocationDetail";
import { useParams } from "react-router-dom";
import { useGetLocationQuery } from "src/generated/graphql";
import NotificationsList from "./Notifications/index";
import { PATH_NAMES } from "src/utils/constants";
import { useAppContext } from "src/api/AppContext";
import Settings from "./Settings";
import DataMigration from "./DataMigration";

export enum TabsName {
  DETAILS = "Location Details",
  WEB_INTEGRATION = "Website Integration",
  NOTIFICATIONS = "Notifications",
  SETTINGS = "Settings",
  DATE_MIGRATION = "Data Migration",
}

const LocationDetails = () => {
  const { currentLocation, currentAdmin } = useAppContext();
  const theme = useMantineTheme();
  let bg = theme.colors.secondary[2];
  let color = theme.colors.secondaryTextColor[6];
  const { locId } = useParams<{ locId: string }>();
  const currentlocId =
    locId === PATH_NAMES.GENERAL_LOC ? currentLocation?.id : locId;

  const [currentTab, setCurrentTab] = useState<TabsName>(TabsName.DETAILS);
  const updateTab = (tabName: TabsName) => {
    setCurrentTab(tabName);
  };

  const { data: locData } = useGetLocationQuery({
    variables: {
      id: currentlocId || "",
    },
    skip: !currentlocId,
  });

  return (
    <Card
      style={{
        //border: `1px ${border}`,
        color,
        overflow: "hidden",
      }}
      radius="md"
      w="100%"
      p={0}
      bg="transparent"
    >
      <Tabs
        styles={{
          tabsList: {
            color,
            padding: "0 15px",
          },
          tab: {
            marginBottom: -2.5,
            fontWeight: 500,
            borderBottomWidth: 3,
          },
          panel: {
            padding: 15,
          },
        }}
        value={currentTab}
        onTabChange={updateTab}
      >
        <Tabs.List bg={bg}>
          {Object.values(TabsName).map((e) => (
            <Tabs.Tab
              key={e}
              value={e}
              style={{
                color: theme.colors.secondaryTextColor[2],
              }}
              sx={{
                "&:hover": {
                  color: `${theme.colors.primary[4]} !important`,
                  borderColor: `${theme.colors.primary[4]} !important`,
                },
              }}
            >
              {e}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        <Tabs.Panel value={TabsName.DETAILS}>
          <LocationDetail locData={locData} />
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.WEB_INTEGRATION}>
          {currentTab === TabsName.WEB_INTEGRATION && (
            <WebIntegration
              orgId={locData?.locationOne?.organization?.id || ""}
              locId={currentlocId!}
            />
          )}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.NOTIFICATIONS}>
          {currentTab === TabsName.NOTIFICATIONS && (
            <NotificationsList locId={currentlocId!} />
          )}
        </Tabs.Panel>
        <Tabs.Panel value={TabsName.SETTINGS}>
          {currentTab === TabsName.SETTINGS && (
            <Settings
              locId={currentlocId!}
              stationsEnabled={locData?.locationOne?.stationsEnabled || false}
            />
          )}
        </Tabs.Panel>

        {!!currentAdmin?.id && (
          <Tabs.Panel value={TabsName.DATE_MIGRATION}>
            {currentTab === TabsName.DATE_MIGRATION && <DataMigration />}
          </Tabs.Panel>
        )}
      </Tabs>
    </Card>
  );
};

export default LocationDetails;
